import strings from "i18n/en";
import { useMemo } from "react";

export const useTranslate = () => {
  const translate = useMemo(() => {
    return (key: string, values?: { [key: string]: string }) => {
      let translatedString = strings[key] || "";
      if (values) {
        Object.entries(values).forEach(([placeholder, replacement]) => {
          translatedString = translatedString.replace(`{${placeholder}}`, replacement);
        });
      }

      return translatedString;
    };
  }, []);

  return translate;
};
